import { AllyBase } from "./base";
import * as elements from "./elements";
import { AllyFunctionMatrix } from "./ally-function-matrix.class";
import { AllyObject } from "./ally-object.class";

/**
 * This class generates the matrix used by the AllyFunctionMatrix.
 * 
 * This class uses the classes in ../elements/ for this purpose.
 * 
 * @extends AllyBase
 * @see AllyFunctionMatrix
 */
export class AllyElements extends AllyBase {
    /**
     * The generated matrix.
     */
    private matrix: AllyFunctionMatrix<AllyObject["scope"]>["matrix"];

    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge);
        this.matrix = [];
        let localElements = elements as unknown as {[key: string]: any};
        for (let i in localElements) {
            new localElements[i](bridge);
        }
        elements.AllyElementBase.init(this.matrix);
    }
    
    /**
     * This function generates a copy of the function-matrix saved in AllyElements["matrix"].
     * @returns Returns the created copy.
     */
    public getMatrix() {
        return AllyFunctionMatrix.copy<AllyObject["scope"]>(this.matrix);
    }
}